import { DateTime } from 'luxon';

import { IConsultationMeetModel } from '@common/models/Consultations/ConsultationMeet';

type Slot = {
	id: number;
	meet: IConsultationMeetModel | null;
	start_dt: string;
	end_dt: string;
	student_id?: number | null;
	[key: string]: any;
};

type NormalizedSlot = Slot & {
	meet: IConsultationMeetModel | null;
};

function normalizeMeets(slots: Slot[]): NormalizedSlot[] {
	const meetGroups = slots.reduce<Record<number, Slot[]>>((acc, slot) => {
		const meetId = slot.meet?.id;
		if (meetId) {
			if (!acc[meetId]) {
				acc[meetId] = [];
			}
			acc[meetId].push(slot);
		}
		return acc;
	}, {});

	const preservedMeetSlotIds = new Set<number>();
	const meetEndTimes: Record<number, string> = {};
	const meetStudentIds: Record<number, number> = {};

	Object.values(meetGroups).forEach((group) => {
		const earliest = group.reduce((a, b) =>
			DateTime.fromSQL(a.start_dt) < DateTime.fromSQL(b.start_dt) ? a : b,
		);
		const latest = group.reduce((a, b) =>
			DateTime.fromSQL(a.end_dt) > DateTime.fromSQL(b.end_dt) ? a : b,
		);

		preservedMeetSlotIds.add(earliest.id);
		meetEndTimes[earliest.id] = latest.end_dt;

		if (earliest.meet?.student?.id) {
			meetStudentIds[earliest.id] = earliest.meet.student.id;
		}
	});

	return slots.map((slot): NormalizedSlot => {
		if (slot.meet?.id && !preservedMeetSlotIds.has(slot.id)) {
			return {
				...slot,
				meet: null,
				student_id: slot.student_id ?? slot.meet?.student?.id ?? null,
			};
		}

		if (preservedMeetSlotIds.has(slot.id)) {
			return {
				...slot,
				end_dt: meetEndTimes[slot.id],
				student_id: slot.student_id ?? meetStudentIds[slot.id] ?? null,
			};
		}

		return slot;
	});
}

export default normalizeMeets;
